import React from 'react'
import { FaExclamationTriangle } from 'react-icons/fa'

function NotAllowedScreen() {
  return (
    <section>
      <div style={{ display: 'flex', direction: 'row', alignItems: 'center' }}>
        <FaExclamationTriangle size={30} color="orange" />
        <h1>Você não tem acesso a esta tela</h1>
      </div>

      <p>Para maiores informações entre em contato com o suporte</p>
      <p>Atendimento em horário comercial: 9h às 18h</p>
    </section>
  )
}

export default NotAllowedScreen
